import { connect } from 'react-redux'
import Component from './Component'
import { findRamsSigning, getRamsSigningPdf, submitRamsSignature } from '../../HttpRequests/ramsSignings'
import { message } from 'antd'

import {
  FETCH_RECORD_REQUEST,
  FETCH_RECORD_SUCCESS,
  FETCH_RECORD_FAILURE,
  FETCH_PDF_REQUEST,
  FETCH_PDF_SUCCESS,
  FETCH_PDF_FAILURE,
  SIGN_REQUEST,
  SIGN_SUCCESS,
  SIGN_FAILURE,
  RESET,
} from './reducer'

const mapStateToProps = (state) => ({
  record: state.screens.RamsSigningView.record,
  loading: state.screens.RamsSigningView.loading,
  error: state.screens.RamsSigningView.error,
  pdfUrl: state.screens.RamsSigningView.pdfUrl,
  pdfLoading: state.screens.RamsSigningView.pdfLoading,
  signing: state.screens.RamsSigningView.signing,
  signed: state.screens.RamsSigningView.signed,
})

const componentDidMount = (id) => async (dispatch) => {
  dispatch({ type: RESET })
  dispatch({ type: FETCH_RECORD_REQUEST })

  try {
    const params = {
      include: [
        'project',
        'project.clientSite',
        'project.clientSite.client',
        'subcontractor',
        'ramsRecord',
      ].join(),
    }
    const response = await findRamsSigning({ id, params })
    dispatch({ type: FETCH_RECORD_SUCCESS, payload: response.data })

    // Mark as viewed
    try {
      const { updateRamsSigning } = require('../../HttpRequests/ramsSignings')
      await updateRamsSigning({ id, data: { viewed: 1 } })
    } catch (e) {
      // ignore view tracking errors
    }

    // Fetch PDF
    dispatch({ type: FETCH_PDF_REQUEST })
    try {
      const pdfResponse = await getRamsSigningPdf({ id })
      const blob = new Blob([pdfResponse.data], { type: 'application/pdf' })
      const url = URL.createObjectURL(blob)
      dispatch({ type: FETCH_PDF_SUCCESS, payload: url })
    } catch (pdfError) {
      dispatch({ type: FETCH_PDF_FAILURE })
    }

  } catch (error) {
    const msg = error.response && error.response.data && error.response.data.error
      ? error.response.data.error
      : error.message
    dispatch({ type: FETCH_RECORD_FAILURE, payload: msg })
  }
}

const onSubmitSignature = (signatureData) => async (dispatch, getState) => {
  const record = getState().screens.RamsSigningView.record
  if (!record) return

  dispatch({ type: SIGN_REQUEST })
  try {
    const response = await submitRamsSignature({ id: record.id, data: signatureData })
    dispatch({ type: SIGN_SUCCESS, payload: response.data.rams_signed })
    message.success('RAMS document signed successfully!')
  } catch (error) {
    dispatch({ type: SIGN_FAILURE })
    const msg = error.response && error.response.data && error.response.data.error
      ? (typeof error.response.data.error === 'string' ? error.response.data.error : 'Validation failed')
      : error.message
    message.error(msg)
  }
}

const mapDispatchToProps = {
  componentDidMount,
  onSubmitSignature,
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)
